import { CatalogCard } from "../../../components/Cards";
import { useDispatch } from "react-redux";
import { atlasSearchByCategory } from "../../../redux/Catalog/catalogActions";
import vert_green_icon from "../../../assets/icons/vert_green.svg";

const Atlas = ({
  isPageOpen,
  categories,
  products,
  selectedCategory,
  setSelectedCategory,
  loading,
  chip,
  setIsClickCategory,
  isClickCategory,
  searchValue,
  informationCard,
  onClick,
}) => {
  const dispatch = useDispatch();

  const handleSelectCategory = (val) => {
    setIsClickCategory(true);
    setSelectedCategory(val);
    dispatch(atlasSearchByCategory({ type: chip?.slug, category_id: val.id }));
  };

  return (
    <div>
      {isPageOpen && (
        <>
          {" "}
          <div
            className={
              chip?.slug === "mechanisation"
                ? ""
                : "mt-0 px-4 border-b border-b-[#E1E6E1] py-3"
            }
          >
            {loading ? (
              <div>
                <ul className="mt-0 flex flex-row flex-wrap gap-3  rounded-lg">
                  {[1, 2, 3, 4, 5]?.map((_, index) => (
                    <div key={index} className="flex items-center">
                      <div className="bg-gray-200 animate-pulse h-[26px] w-16 rounded-[4px]"></div>
                    </div>
                  ))}
                </ul>
              </div>
            ) : (
              <div>
                <div className="mt-0 flex flex-row flex-wrap gap-3  rounded-lg">
                  {categories?.map((val) => (
                    <ul className="mt-0 flex flex-row flex-wrap gap-3  rounded-lg">
                      <li
                        key={val.id}
                        onClick={() => handleSelectCategory(val)}
                        className={
                          selectedCategory.id === val.id
                            ? "bg-[#DBFFDF] text-primary text-sm font-semibold px-1 py-[2px] rounded-lg cursor-pointer"
                            : "bg-[#ECEEEC] w-fit text-[#5F6D60] text-sm font-semibold px-1 py-[2px] rounded-[4px] cursor-pointer"
                        }
                      >
                        {val.name}
                      </li>
                    </ul>
                  ))}
                </div>
              </div>
            )}
          </div>
          {searchValue.length > 0 ? (
            <>
              <div className="mt-4 px-4">
                <h5 className="text-[#344335] text-sm">
                  Search results for : "{searchValue}"
                </h5>
              </div>

              {informationCard.length > 0 && (
                <div className="mt-4 bg-[#EDF7EE] flex gap-4 justify-between rounded-[5px] py-5 px-5 mx-4">
                  <div>
                    <h6 className="text-[#344335] font-semibold text-sm">
                      {informationCard[0].product_name}
                    </h6>
                    <p className="text-[#344335] text-sm font-medium mt-2">
                      {informationCard[0].product_information}
                    </p>
                  </div>
                  <div className="flex-shrink-0 cursor-pointer">
                    <img src={vert_green_icon} alt="vert" />
                  </div>
                </div>
              )}
            </>
          ) : (
            ""
          )}
          <div className="mt-0  py-3">
            <div className="mt-0 flex flex-col flex-wrap gap-3 rounded-lg w-full ">
              {(selectedCategory.id ? [""] : categories)?.map((val) => {
                const categoryProducts = !isClickCategory
                  ? products.filter((data) => data.category.id === val.id)
                  : products;

                if (!selectedCategory.id && categoryProducts.length === 0) {
                  return null;
                }

                return (
                  <div key={val.id} className="w-full">
                    {selectedCategory.id ? null : (
                      <div>
                        {loading ? (
                          <div className="flex items-center h-[34px] bg-[#F6F7F6] px-4 overflow-x-auto w-full py-1 rounded-[4px]">
                            <div className="bg-gray-200 animate-pulse h-2 w-24 rounded"></div>
                          </div>
                        ) : (
                          <div className="flex items-center h-[34px] bg-[#F6F7F6] px-4 overflow-x-auto  w-full text-[#5F6D60] text-sm font-semibold py-1 rounded-[4px] cursor-pointer">
                            <p>{val.name}</p>
                          </div>
                        )}
                      </div>
                    )}

                    {loading ? (
                      <div className="flex overflow-x-auto campaignScroll gap-0 scrollbar-hide">
                        {["1", "2", "3", "4", "5"]?.map((_, index) => (
                          <div
                            key={index}
                            className="bg-white rounded-lg animate-pulse pt-2 px-2"
                          >
                            <div className="rounded-lg bg-gray-200 w-[172px] h-[172px] "></div>
                            <div className="h-4 bg-gray-200 rounded w-3/4 mt-2"></div>
                            <div className="h-3 bg-gray-200 rounded w-full mt-1"></div>
                          </div>
                        ))}
                      </div>
                    ) : (
                      <div className="flex overflow-x-auto campaignScroll gap-0 scrollbar-hide">
                        {categoryProducts?.map((item) => (
                          <div
                            className="pt-2 px-2 cursor-pointer"
                            onClick={() => onClick(item)}
                          >
                            <CatalogCard
                              key={item.id}
                              name={item.name}
                              noOfVariants={item.variant_count}
                              image={
                                item?.images && item?.images?.length !== 0
                                  ? item?.images[0]
                                  : "https://res.cloudinary.com/dnwibstsw/image/upload/v1751373048/Frame_26080734_u6pgyj.png"
                              }
                              description={item.description}
                            />
                          </div>
                        ))}
                      </div>
                    )}
                  </div>
                );
              })}
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default Atlas;
